<template>
  <div>
    <!-- presets -->
    <v-row :width="rowWidth">
      <v-col md="6" lg="6" xl="4" v-for="preset in presets" v-bind:key="preset.id">
        <wapi-preset-card :preset="preset" @open-preset="openPreset" @delete-preset="deletePreset" />
      </v-col>
    </v-row>
    <!-- pagination -->
    <v-row v-show="pagination">
      <v-col class="text-center">
        <v-pagination
          v-model="page"
          :length="paginationLength"
          :total-visible="paginationTotalVisible"
        ></v-pagination>
      </v-col>
    </v-row>
    <!--диалоговое окно удаления  -->
    <v-row>
      <v-dialog style="z-index: 99998" v-model="deleteDialog" max-width="290">
        <v-card>
          <v-card-title class="headline">Удаление</v-card-title>

          <v-card-text>Уверены что хотите удалить территорию {{ preset.id }}?</v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="green darken-1" text @click="deleteDialog = false">Отмена</v-btn>

            <v-btn color="green darken-1" text @click="confirmDeletePreset()">Удалить</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { areaInKm2 } from "../helpers/common.js";
import WapiPresetCard from "./WapiPresetCard.vue";

export default {
  name: "ManagedPresets",
  components: {
    WapiPresetCard
  },
  props: {
    userId: {
      type: String,
      default: ""
    },
    predicts: {
      type: Array,
      default: function() {
        return [];
      }
    },
    pvariants: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data: function() {
    return {
      totalPresets: 0,
      page: 1,
      preset: {},
      paginationTotalVisible: 10,
      perPage: 6,
      geoJsonOptions: {
        onEachFeature: (feature, layer) => {
          const bounds = layer.getBounds();
          layer.getLatLng = function() {
            return this.getBounds().getCenter();
          };
          layer.setLatLng = function() {};
          layer._latlng = layer.getLatLng();
          const mapId = this.presets.findIndex(x => x.area.id === feature.id);
          this.$refs.maps[mapId].mapObject.fitBounds(bounds);
        }
      },
      deleteDialog: false,
      rowWidth: null
    };
  },
  watch: {
    async userId(val) {
      const take = this.perPage;
      const skip = 0;

      if (this.isAdmin) {
        this.totalPresets = await this.$store.dispatch(
          "FETCH_PRESET_COUNT_USER",
          {
            userId: val
          }
        );

        await this.$store.dispatch("FETCH_PRESETS", {
          userId: val,
          take: take,
          skip: skip
        });
      } else {
        this.totalPresets = await this.$store.dispatch(
          "FETCH_PRESET_COUNT",
          {}
        );

        await this.$store.dispatch("FETCH_USER_PRESETS", {
          take: take,
          skip: skip
        });
      }
    },
    async page(val) {
      const take = this.perPage;
      const skip = (val - 1) * this.perPage || 0;

      await this.$store.dispatch("SET_LOADING", true);
      if (this.isAdmin) {
        this.totalPresets = await this.$store.dispatch(
          "FETCH_PRESET_COUNT_USER",
          {
            userId: this.userId
          }
        );

        await this.$store.dispatch("FETCH_PRESETS", {
          userId: this.userId,
          take: take,
          skip: skip
        });
      } else {
        this.totalPresets = await this.$store.dispatch(
          "FETCH_PRESET_COUNT",
          {}
        );

        await this.$store.dispatch("FETCH_USER_PRESETS", {
          take: take,
          skip: skip
        });
      }

      await this.$store.dispatch("SET_LOADING", false);
    }
  },
  computed: {
    md() {
      if (this.rowWidth < 1160) {
        return 6;
      }

      return 4;
    },
    presets() {
      return this.$store.getters.PRESETS;
    },
    paginationLength() {
      return Math.ceil(this.totalPresets / this.perPage);
    },
    pagePresets() {
      const from = (this.page - 1) * this.perPage;
      const to = this.page * this.perPage;
      return this.presets.slice(from, to);
    },
    pagination() {
      return !!this.presets.length;
    },
    isAdmin() {
      return this.$store.getters.IS_ADMIN;
    }
  },
  methods: {
    deletePreset(preset) {
      this.preset = preset;
      this.deleteDialog = true;
    },
    async confirmDeletePreset() {
      this.deleteDialog = false;
      await this.$store.dispatch("DELETE_PRESET", this.preset);
    },
    areaInKm(geojson) {
      const area = Math.round(areaInKm2(geojson.geometry));
      return area;
    },
    areaInHa(geojson) {
      const area = Math.round(areaInKm2(geojson.geometry));
      return area;
    },
    openPreset(preset) {
      this.$router.push({
        name: "PRESET_DETAILS",
        params: { userId: preset.user_id, presetId: preset.id }
      });
    }
  }
};
</script>